import React, { useState } from 'react';
import ArticlesList from '../components/admin/ArticlesList';
import ArticleEditor from '../components/admin/ArticleEditor';
import KeywordsGenerator from '../components/admin/KeywordsGenerator';
import QuickGenerate from '../components/admin/QuickGenerate';
import AffiliateManager from '../components/admin/AffiliateManager';
import '../styles/admin.css';

const AdminPage = () => {
    const [isAuthenticated, setIsAuthenticated] = useState(false);
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);
    const [activeTab, setActiveTab] = useState('articles');
    const [editorState, setEditorState] = useState({ mode: 'list', articleId: null, initialData: null });

    const handleLogin = async (e) => {
        e.preventDefault();
        setLoading(true);
        setError('');
        try {
            const response = await fetch('/.netlify/functions/verify-admin', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ password }),
            });
            const data = await response.json();
            if (data.authenticated) {
                setIsAuthenticated(true);
            } else {
                setError(data.error || 'Wrong password mate');
            }
        } catch (err) {
            setError('Failed to verify - are you running Netlify Dev?');
        } finally {
            setLoading(false);
        }
    };

    const handleNewArticle = () => {
        setEditorState({ mode: 'editor', articleId: null, initialData: null });
        setActiveTab('articles');
    };

    const handleEditArticle = (articleId) => {
        setEditorState({ mode: 'editor', articleId, initialData: null });
        setActiveTab('articles');
    };

    const handleBackToList = () => {
        setEditorState({ mode: 'list', articleId: null, initialData: null });
    };

    const handleArticleGenerated = (data) => {
        setEditorState({ mode: 'editor', articleId: null, initialData: data });
        setActiveTab('articles');
    };

    if (!isAuthenticated) {
        return (
            <div className="admin-login">
                <h1>Admin Login</h1>
                <form className="admin-login-form" onSubmit={handleLogin}>
                    <input
                        type="password"
                        placeholder="Enter password"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        autoFocus
                    />
                    <button type="submit" disabled={loading}>{loading ? 'Verifying...' : 'Login'}</button>
                </form>
                {error && <div className="admin-error">{error}</div>}
            </div>
        );
    }

    return (
        <div className="admin-dashboard">
            <div className="admin-header">
                <h1>BetterSleep Admin</h1>
                <button className="admin-logout" onClick={() => setIsAuthenticated(false)}>
                    Logout
                </button>
            </div>

            <div className="admin-tabs">
                <button
                    className={`admin-tab ${activeTab === 'articles' ? 'active' : ''}`}
                    onClick={() => { setActiveTab('articles'); handleBackToList(); }}
                >
                    Articles
                </button>
                <button
                    className={`admin-tab ${activeTab === 'generator' ? 'active' : ''}`}
                    onClick={() => setActiveTab('generator')}
                >
                    AI Generator
                </button>
                <button
                    className={`admin-tab ${activeTab === 'quick' ? 'active' : ''}`}
                    onClick={() => setActiveTab('quick')}
                >
                    Quick Generate
                </button>
                <button
                    className={`admin-tab ${activeTab === 'affiliates' ? 'active' : ''}`}
                    onClick={() => setActiveTab('affiliates')}
                >
                    Affiliates
                </button>
            </div>

            <div className="admin-content">
                {activeTab === 'articles' && editorState.mode === 'list' && (
                    <ArticlesList onEdit={handleEditArticle} onNew={handleNewArticle} />
                )}
                {activeTab === 'articles' && editorState.mode === 'editor' && (
                    <ArticleEditor
                        articleId={editorState.articleId}
                        onBack={handleBackToList}
                        initialData={editorState.initialData}
                    />
                )}
                {activeTab === 'generator' && (
                    <KeywordsGenerator onArticleGenerated={handleArticleGenerated} />
                )}
                {activeTab === 'quick' && (
                    <QuickGenerate />
                )}
                {activeTab === 'affiliates' && (
                    <AffiliateManager />
                )}
            </div>
        </div>
    );
};

export default AdminPage;
